import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
Vue.use(Router)

export default new Router({
  mode: 'history', // See: https://router.vuejs.org/en/essentials/history-mode.html
  routes,
  scrollBehavior (to, from, savedPosition) {
    return {x: 0, y: 0}
  }
})



// WEBPACK FOOTER //
// ./src/router/router.js